
mutation INVESTOR_INTEREST (
  $company: NonEmptyString!
  $email: NonEmptyString!
  $firstName: NonEmptyString!
  $lastName: NonEmptyString!
  $phone: String
  $zipCode: NonEmptyString!
  $contactType: ContactType!
  $inquiryFor: InquiryFor!
) {
  createContactInquiryForm(
    company: $company
    email: $email
    firstName: $firstName
    lastName: $lastName
    phone: $phone
    zipCode: $zipCode
    contactType: $contactType
    inquiryFor: $inquiryFor
  ) {
    success
    error
    contactInquiry {
      company
      contactType
      createdDatetime
      email
      firstName
      id
      inquiryFor
      lastName
      phone
      updatedDatetime
      zipCode
    }
  }
}
